module.exports = __webpack_public_path__ + "img/landing48.cbe82fb0.jpg";